module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Sad-d84bf91d268654e19763327d36d85be5.svg";